<template>
  <div class="welcome-page">
    <div class="welcome-card">
      <h1 class="welcome-title">You're In — Welcome to Kiey</h1>
      <p class="welcome-body">
        Download the Kiey app on your phone to add your team, manage clients,
        and run your business.
      </p>

      <div class="store-badges">
        <a
          :href="appleStoreUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="store-badge-link"
          aria-label="Download on the App Store"
        >
          <img
            :src="require('@/assets/img/apple_store.svg')"
            alt="Download on the App Store"
            class="store-badge"
          />
        </a>
        <a
          :href="googlePlayUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="store-badge-link"
          aria-label="Get it on Google Play"
        >
          <img
            :src="require('@/assets/img/google_play.svg')"
            alt="Get it on Google Play"
            class="store-badge"
          />
        </a>
      </div>

      <p class="welcome-confirmation">
        Confirmation has been sent to your email and phone.
      </p>

      <p class="welcome-secondary">
        <a :href="adminPanelUrl" class="welcome-secondary-link">
          Continue to the admin panel &rarr;
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "OwnerSignUpDownloadApp",
  data() {
    return {
      // Admin panel landing — pulled from env so staging stays on
      // staging.kiey.com and prod stays on admin.kiey.com. Falls back
      // to admin.kiey.com if the env var isn't defined.
      adminPanelUrl: process.env.VUE_APP_HOST_URL || "https://admin.kiey.com",
    };
  },
  computed: {
    appleStoreUrl() {
      return this.$store.getters["Authenticate/getAppleStoreUrl"];
    },
    googlePlayUrl() {
      return this.$store.getters["Authenticate/getGooglePlayUrl"];
    },
  },
};
</script>

<style scoped>
.welcome-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  background-color: #f5f7fb;
}

.welcome-card {
  width: 100%;
  max-width: 560px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 48px 32px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(6, 29, 71, 0.08);
  box-sizing: border-box;
}

.welcome-title {
  color: #061d47;
  font-family: "Roboto-Medium", Arial, sans-serif;
  font-size: 28px;
  font-weight: 600;
  line-height: 1.25;
  margin: 0 0 16px 0;
}

.welcome-body {
  color: #4a4a4a;
  font-family: Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  margin: 0 0 32px 0;
}

.store-badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
}

.store-badge-link {
  display: inline-block;
  text-decoration: none;
  line-height: 0;
}

.store-badge {
  height: 56px;
  width: auto;
  display: block;
}

.welcome-confirmation {
  color: #6a6a6a;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 0 24px 0;
}

.welcome-secondary {
  margin: 0;
}

.welcome-secondary-link {
  color: #3256a4;
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
}

.welcome-secondary-link:hover {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .welcome-card {
    padding: 32px 20px;
  }

  .welcome-title {
    font-size: 24px;
  }

  .welcome-body {
    font-size: 15px;
  }

  .store-badge {
    height: 48px;
  }
}
</style>
